import { ClassicQueue } from "@ciaopeople/cp-shatsu/Queues";
import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { getSecondLevelDomain } from "@mp-commons/lib/utils/DomainNameUtils.js";
import { getCPNetworkByCPProduct, getCPProductFromHostname } from "@mp-commons/config/CPProducts.js";
import { ExternallyPassedContentAdData, isExternallyPassedContentAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { VideoPolicyRules } from "@mp-commons/modules/ads/vprules/VideoPolicyRules.js";
import { MegarideEmbeddablePlayerConfig, ParthenopePlayerConfig, isMegarideEmbeddablePlayerConfig } from "../MegaridePlayerConfig.js";
import { ParthenopePlayerV3 } from "../parthenope/ParthenopePlayerV3.js";
import { CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";
import { getPosterUrl, PosterFormat } from "@mp-commons/model/MediaThumbnailResource.js";
import { VideoPlaylist, isVideoPlaylist } from "@mp-commons/model/video/VideoPlaylist.js";


function buildParthenope(playlist: VideoPlaylist,
    extAdData: ExternallyPassedContentAdData,
    embeddablePlayerConfig: MegarideEmbeddablePlayerConfig,
    htmlRoot: HTMLElement,
    win?: Window,
    prefetchResources?: string[]): Promise<void> {


    const fullHostname = window.document.location.host;
    const secondLevel = getSecondLevelDomain(fullHostname);
    const productContext = getCPProductFromHostname(secondLevel);
    const product = getCPNetworkByCPProduct(productContext);


    Promise.all(prefetchResources.map(url => fetch(url))).then(r => console.log("Finito prefetch resources"))


    // check input parameters
    const embeddablePlayerConfigCheck: Promise<MegarideEmbeddablePlayerConfig> = new Promise((resolve, reject) => {
        if (isMegarideEmbeddablePlayerConfig(embeddablePlayerConfig)) {
            resolve(embeddablePlayerConfig);
        } else {
            reject("Invalid embeddablePlayerConfig");
        }
    });

    const externallyPassedContentAdDataCheck: Promise<ExternallyPassedContentAdData> = new Promise((resolve, reject) => {
        if (isExternallyPassedContentAdData(extAdData)) {
            resolve(extAdData);
        } else {
            reject("Invalid external content ad data");
        }
    });

    const playlistCheck: Promise<VideoPlaylist> = new Promise((resolve, reject) => {
        if (isVideoPlaylist(playlist)) {
            resolve(playlist);
        } else {
            reject("Invalid videos input");
        }
    });



    return Promise.all([embeddablePlayerConfigCheck, externallyPassedContentAdDataCheck, playlistCheck]).then(
        ([embeddableConfig, externalContentAdData, playlist]) => {
            const useWindow = win ? win : window;

            //?PERF: LCP - load poster ASAP
            const initialPoster = playlist && playlist.elements.length > 0 ? getPosterUrl(playlist.elements[0].thumbnail, undefined, externalContentAdData.embedType == CP_EmbedType.FANPLAYER ? PosterFormat.SMALL : undefined) : null;

            const config: ParthenopePlayerConfig = {
                initialPoster: initialPoster,
                domain: {
                    network: product,
                },
                reuseExistingVideoElement: true,
                embeddablePlayerConfig: {
                    ...embeddableConfig,
                    videoPolicy: embeddableConfig.videoPolicy ? embeddableConfig.videoPolicy : VideoPolicyRules.GOOGLE_UPDATED_VIDEO_POLICY
                },
                prebid: {
                    enable: true,
                    timeout: 1000,
                    amazon: {
                        pubID: "3597"
                    },
                    ias: {
                        pubId: "930840",
                        anId: "931226"
                    }
                },
                comscoreLoadMode: "jit",
                onlyVideoPoster: externalContentAdData.embedType == CP_EmbedType.FANPLAYER,
                enableStoryboard: true,
            }
            return ParthenopePlayerV3.build(playlist, config, externalContentAdData, htmlRoot, useWindow).then(p => {
                if ("onMegaridePlayerInit" in useWindow && isFunction(useWindow["onMegaridePlayerInit"])) useWindow.onMegaridePlayerInit(p);
                p.init()
            });
        }
    ).catch((e) => {
        console.error("There was an error during player initialization", e);
    });


}

const QUEUE = "_parthenopeq";
const queue = new ClassicQueue(window, QUEUE);
queue.resolve(buildParthenope);
